
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FracpackDefinitionAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FracpackDefinitionAsset"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Asset"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"probability"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":146}};
    doc.loc.source = {"body":"#import \"@/graphql/fragments/Asset.gql\"\n\nfragment FracpackDefinitionAsset on FracpackDefinitionAsset {\n  asset {\n    ...Asset\n  }\n  probability\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/Asset.gql").definitions));


      module.exports = doc;
    
